module.exports = __webpack_public_path__ + "static/media/united_states.8b588113.svg";